<template>
    <div class="split-dialog">
        <el-dialog
            :visible.sync="visible"
            :title="$t('Sell.Dialog.split')" left>
            <div class="split-dialog-content">
                <span class="split-title-text text-right">
                    {{ $t('Sell.Pay.amounts_payable') }}：</span>
                     {{ info.payableAmtStr }}
            </div>
            <el-form
                ref="form"
                :model="form"
                :rules="rules"
                label-suffix=":"
                label-width="100px"
                label-position="right">
                <el-form-item
                    class="split-dialog-box"
                    :label="$t('Sell.Dialog.main_saler')"
                    v-if="info.primarySales">
                    <div class="flex">
                        <el-select
                            @change="searchText = null"
                            class="pr-2"
                            v-model="info.primarySales.id">
                            <input
                                v-model="searchText"
                                class="search-input-all"
                                type="text" >
                            <el-option
                                v-for="(item, iindex) in filterList"
                                :key="iindex"
                                :label="item.nickname"
                                :value="Number(item.id)"
                                :disabled="item.id === 'no'">
                            </el-option>
                        </el-select>
                        <el-input
                            style="width: 80px;"
                            v-model.number="info.primarySales.percent">
                        </el-input>
                        &nbsp;% {{ $t('Course.about') }}
                        <span v-if="info.primarySales.percent">
                            {{ (Number(info.primarySales.percent / 100) * Number(info.payableAmt)).toFixed(2) }}
                        </span>
                        {{ $t('Reception.Fifth.yuan') }}
                    </div>
                </el-form-item>
                <div v-if="arr.length" v-for="(item, index) in arr" :key="index">
                    <el-form-item :label="$t('Sell.Dialog.assist_saler')" class="split-dialog-box">
                        <div class="flex relative">
                            <i
                                @click="deleteItem(index)"
                                class="el-icon-close split-icon-close">
                            </i>
                            <el-select
                                @change="searchText = null"
                                class="pr-2"
                                v-model="item.id">
                                <input
                                    @input="filterSaler(index)"
                                    v-model="search[index].searchText"
                                    class="search-input-all"
                                    type="text" >
                                <el-option
                                    v-for="(item, iindex) in search[index].staffs"
                                    :key="iindex"
                                    :label="item.nickname"
                                    :value="Number(item.id)"
                                    :disabled="item.id === 'no'">
                                </el-option>
                            </el-select>
                            <el-input
                                style="width: 80px;"
                                v-model.number="item.percent">
                            </el-input>
                            &nbsp;% {{ $t('Course.about') }}
                            <span v-if="item.percent">
                                {{ (Number(item.percent / 100) * Number(info.payableAmt)).toFixed(2) }}
                            </span>
                            {{ $t('Reception.Fifth.yuan') }}
                        </div>
                    </el-form-item>
                </div>
                <el-button @click="handleAdd" icon="el-icon-plus">
                    {{ $t('Sell.Dialog.assist_saler') }}
                </el-button>
                <el-form-item :label="$t('Common.remark')" class="split-dialog-remark">
                    <el-input :rows="6" v-model="form.remark" type="textarea"></el-input>
                </el-form-item>
            </el-form>
            <div class="text-center">
                <el-button @click="submit" type="primary">
                    {{ $t('Sell.Dialog.modify_btn') }}
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { Dialog, DatePicker, Radio, RadioGroup } from 'element-ui';
import filterRole from '@/mixins/filterRole.js';

export default {
    components: {
        ElDialog: Dialog,
        ElDatePicker: DatePicker,
        ElRadio: Radio,
        ElRadioGroup: RadioGroup,
    },
    props: ['activeName'],
    mixins: [filterRole],
    data() {
        return {
            visible: false,
            contractNum: null,
            info: {},
            form: {
                remark: null,
            },
            rules: {},
            type: null,
            staffs: [],
            // 主要售卖人
            searchText: null,
            arr: [],
            search: [],
        };
    },
    computed: {
        filterList() {
            if (!this.searchText) return this.staffs;
            const arr = this.staffs.filter(item =>
                item.nickname.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1);
            return arr.length ? arr : [{id: 'no', nickname: this.$t('Common.data_not_found')}];
        },
    },
    watch: {
        'visible'(val) {
            if (!val) this.resetForm();
        },
    },
    methods: {
        resetForm() {
            this.form = {
                remark: null,
            };
            setTimeout(() => {
                this.$refs.form.resetFields();
            }, 0);
        },
        open(data) {
            this.contractNum = data.contractNum;
            this.getDesc();
            this.fetchStaff();
        },
        getDesc() {
            if (this.activeName === 'member') this.type = 'mshp';
            else if (this.activeName === 'personal') this.type = 'coach';
            else if (this.activeName === 'locker') this.type = 'locker';
            else if (this.activeName === 'cardsCon') this.type = 'cz-card';
        },
        async fetchStaff() {
            let ids;
            if (this.activeName === 'member') ids = [5, 6];
            else if (this.activeName === 'personal') ids = [7, 8];
            else ids = null;
            this.staffs = await this.filterRole(null, ids, null);
            this.fetchData();
        },
        fetchData() {
            API.get(`contract/${this.type}/${this.contractNum}/performance`)
            .then(res => {
                this.info = res;
                this.arr = res.assistSales;
                if (this.arr.length) {
                    this.search = this.arr.map(el => {
                        const item = {
                            searchText: null,
                            staffs: this.staffs,
                        }
                        return item;
                    });
                };
                this.visible = true;
            });
        },
        handleAdd() {
            this.arr.push({
                id: null,
                nickname: null,
                salesTypeCode: 2,
                salesType: this.$t('Sell.Dialog.assist_saler'),
                percent: null,
            });
            this.search.push({
                searchText: null,
                staffs: this.staffs,
            });
        },
        deleteItem(index) {
            this.arr.splice(index, 1);
            this.search.splice(index, 1);
        },
        filterSaler(index) {
            const value = this.search[index].searchText;
            if (!value) this.search[index].staffs = this.staffs;
            const arr = this.staffs.filter(item =>
                item.nickname.toLowerCase().indexOf(value.toLowerCase()) > -1);
            this.search[index].staffs = arr.length ? arr : [{id: 'no', nickname: this.$t('Common.data_not_found')}];
        },
        submit() {
            // this.$refs.form.validate(valid => {
            //     if (!valid) return;
            //     this.postData();
            // });
            this.postData();
        },
        postData() {
            let form = {
                remark: this.form.remark,
                assistSales: [],
                primarySales: {},
            };
            form.assistSales = this.arr.map(el => {
                const item = {
                    id: el.id,
                    percent: el.percent,
                };
                return item;
            });
            form.primarySales = {
                id: this.info.primarySales.id,
                percent: Number(this.info.primarySales.percent),
            };
            const ids = this.arr.map(el => el.id);
            const id = this.info.primarySales.id;
            if (ids.includes(id)) return $ele.$message(this.$t('Message.repeat_saler'));
            API.post(`contract/${this.type}/${this.contractNum}/performance`, form)
            .then(() => {
                $ele.$message.success(this.$t('Message.success'));
                this.visible = false;
                this.$emit('fetchData');
            });
        },
    },
};
</script>
<style lang="scss">
.split-dialog {
    .el-dialog {
        width: 710px;
        max-height: 521px;
    }
    .el-dialog__body {
        height: 460px;
        overflow-y: auto;
    }
}
.split-dialog-content {
    width: 100%;
    padding: 10px;
    margin-bottom: 15px;
}
.split-dialog-box {
    min-height: 30px;
    margin-bottom: 10px;
    padding: 15px;
    background: #eee;
    .el-form-item {
        margin-bottom: 0;
    }
}
.split-title-text {
    font-size: 12px;
    display: inline-block;
    padding-right: 6px;
}
.split-icon-close {
    position: absolute;
    top: 10px;
    right: 10px;
    font-weight: 500;
}
.split-dialog-remark {
    margin-top: 15px;
    .el-form-item__label {
        width: auto !important;
    }
    .el-form-item__content {
        margin-left: 0 !important;
    }
}
</style>
